<template>
  <div class="message-button-create" @click="create">
    メッセージの作成
  </div>
</template>

<script>
import MixinResultHandler from '@/components/MixinResultHandler'

export default {
  mixins: [ MixinResultHandler ],
  methods: {
    create: async function () {
      const result = await this.$store.dispatch(
        'message/saveMessage',
        'new'
      )

      this.showSnackAndMove(result)
    }
  }
}
</script>

<style lang="scss" scoped>
.message-button-create {
  @include button-ol-success;
}
</style>
